import ReactJson, { type ReactJsonViewProps } from 'react-json-view'
import { useTranslation } from 'react-i18next'

import { Body1, Box, Card, H5 } from '@dhl-ui/components'
import type { LabelRequestDto } from '~/modules/label/model'
import { LabelRequestHeader, DownloadButton } from '~/modules/label/components'

type Props = {
  labelRequest: LabelRequestDto
}
const reactJsonProps: Omit<ReactJsonViewProps, 'src'> = {
  name: false,
  theme: 'summerfruit:inverted',
  enableClipboard: true,
  displayDataTypes: false,
  displayObjectSize: true,
  quotesOnKeys: true,
  indentWidth: 2,
  sortKeys: true,
}
export const LabelRequest = ({ labelRequest }: Props) => {
  const { t } = useTranslation()
  const pieceId = labelRequest.trackerCodes[0] ?? ''
  return (
    <Box pb={2} mt={3} data-testid="label-request">
      <Card>
        <Box p={2} pl={3}>
          <LabelRequestHeader labelRequest={labelRequest} pieceId={pieceId} />
        </Box>
        <Box p={2} pl={3}>
          <H5>{t('admin.labelPage.clientAddress')}</H5>
          <Body1>{labelRequest.remoteAddress}</Body1>
        </Box>
        <Card.Header
          title={t('admin.labelPage.jsonBody')}
          endNode={<DownloadButton filename={`${pieceId}-body.json`} payload={labelRequest.body} />}
        />
        <Card>
          <ReactJson src={labelRequest.body} {...reactJsonProps} />
        </Card>
      </Card>
      <Box mt={3}>
        <Card>
          <Card.Header
            title={t('admin.labelPage.authentication')}
            endNode={<DownloadButton filename={`${pieceId}-auth.json`} payload={labelRequest.auth} />}
          />
          <Card>
            <ReactJson src={labelRequest.auth} {...reactJsonProps} />
          </Card>
        </Card>
      </Box>
      <Box mt={3}>
        <Card>
          <Card.Header
            title={t('admin.labelPage.specification')}
            endNode={<DownloadButton filename={`${pieceId}-specification.json`} payload={labelRequest.specification} />}
          />
          <Card>
            <ReactJson src={labelRequest.specification} {...reactJsonProps} />
          </Card>
        </Card>
      </Box>
      <Box mt={3}>
        <Card>
          <Card.Header
            title={t('admin.labelPage.complete')}
            endNode={<DownloadButton filename={`${pieceId}.json`} payload={labelRequest} />}
          />
          <Card>
            <ReactJson src={labelRequest} {...reactJsonProps} />
          </Card>
        </Card>
      </Box>
    </Box>
  )
}
